<template>
  <header class="header">
    <img class="logo-img" alt src="@/assets/logo.png" />
    <NavBar></NavBar>
    <UserMenu></UserMenu>
  </header>
</template>

<script>
import NavBar from "./NavBar"
import UserMenu from "./UserMenu"
export default {
  name: "Header",
  components: { NavBar, UserMenu },
  computed: {}
}
</script>

<style scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 16px;
  background-color: var(--blue-light);
}

.logo-img {
  width: 88px;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/layout/desktop/Header.vue